import React, { useEffect, useState } from "react";

import { MenuModuleType, readMenuModule } from "../../../../utils/storage";
import { subscribeMenuModule } from "../../../../utils/ps";

import clsName from './index.module.less'

type CrumbRecord = [string, string | undefined]

interface ButtonProps {
  children: string
  href?: string
}
const Button: React.FC<ButtonProps> = ({ children, href })=> {
  if (href) {
    return (
      <div className={clsName.inner}>
        <a href={href} className={clsName.trigger}>{children}</a>
      </div>
    )
  }
  return (
    <div className={clsName.inner}>
      <button className={clsName.trigger} type="button">{children}</button>
    </div>
  )
}

const CrumbsNav = ()=> {

  const [items, setItems] = useState<CrumbRecord[]>([])

  useEffect(()=> {
    subscribeMenuModule(()=> {
      const menu = readMenuModule()

      if (!menu) {
        return
      }

      const part = menu as MenuModuleType

      const pieces: CrumbRecord[] = [];

      if (part.levelOneTitle) {
        pieces.push([part.levelOneTitle, undefined])
      }
      if (part.levelTwoTitle) {
        pieces.push([part.levelTwoTitle, part.levelTwoUrl as string])
      }
      if (part.levelThreeTitle) {
        pieces.push([part.levelThreeTitle, undefined])
      }
      setItems(pieces)
    })
  }, [])

  return (
    <div className={clsName.wrapper}>
      {
        items.map(([label, href], index)=> (
          <Button key={index} href={href}>{label}</Button>
        ))
      }
    </div>
  )
}

export default CrumbsNav